import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, ValidationOptions, registerDecorator } from 'class-validator';
import CloudOrganizationsStore from '@/store/modules/CloudOrganizationsStoreModule';
import { CloudOrganizationsStoreModule, TenantDetailsStoreModule } from '@/store';
import TenantDetailsStore from '@/store/modules/TenantDetailsStoreModule';
import { CloudType } from '../../../Enums';

@ValidatorConstraint()
export class TenantDetailsValidatorIsCloudIdUniqueContraint implements ValidatorConstraintInterface {

    cloudOrganizations$: CloudOrganizationsStore = CloudOrganizationsStoreModule;
    tenantDetails$: TenantDetailsStore = TenantDetailsStoreModule;

    validate(value: string, validationArguments: ValidationArguments) {
        let cloudType: string = CloudType.Aws;
        if (validationArguments.property === 'cloudOrganizationId') {
            cloudType = CloudType.Azure;
        }

        value = value.toLowerCase();
        return this.cloudOrganizations$.cloudOrganizations.filter((c) => c.cloudType.toLowerCase() === cloudType &&
                c.cloudId.toLowerCase() === value &&
                c.tenantId.toLowerCase() !== this.tenantDetails$.tenantDetails!.tenantId.toLowerCase()).length === 0;
    }
}

export function TenantDetailsValidatorIsCloudIdUnique(validationOptions?: ValidationOptions) {
    return (object: any, propertyName: string) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [],
            validator: TenantDetailsValidatorIsCloudIdUniqueContraint,
        });
    };
}
